import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChatCircle } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';

interface StickyMobileCTAProps {
  heroRef: React.RefObject<HTMLDivElement | null>;
}

export default function StickyMobileCTA({ heroRef }: StickyMobileCTAProps) {
  const { currentUser } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [heroRef]);

  if (currentUser || !visible) return null;

  return (
    <div className="fixed left-0 right-0 z-30 md:hidden px-4 pb-2" style={{ bottom: 'calc(3.5rem + env(safe-area-inset-bottom, 0px) + 0.5rem)' }}>
      <Link
        to="/chat"
        className="flex items-center justify-center gap-2 w-full py-3 bg-gradient-to-r from-orange-500 to-pink-500 text-white font-semibold rounded-xl shadow-lg hover:from-orange-600 hover:to-pink-600 transition-all"
      >
        <ChatCircle size={20} weight="fill" />
        Chat with Romy
      </Link>
    </div>
  );
}
